import "./App.css";
import { Splash } from "./pages/Splash";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Work from "./pages/Work";
import { Profile } from "./pages/Profile";
import { useEffect, useState } from "react";

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.outerWidth < 768); // 768px is typical mobile breakpoint
    };

    // Check on mount
    checkIsMobile();

    // Add event listener for window resize
    window.addEventListener("resize", checkIsMobile);

    // Cleanup
    return () => window.removeEventListener("resize", checkIsMobile);
  }, []);

  return isMobile;
};

function App() {
  const isMobile = useIsMobile();
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Routes>
        <Route path="/" element={<Splash isMobile={isMobile} />}></Route>
        <Route path="/work" element={<Work isMobile={isMobile} />} />
        <Route path="/profile" element={<Profile isMobile={isMobile} />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
